import { Box, Button, FormHelperText } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";
import PrepaymentDetailsModal from "./PrepaymentDetailsModal";
import dayjs from "dayjs";

const getPrepaymentErrorMessage = (error) => {
  if (!error) return null;

  const refErrors = error.prepayment_invoice_reference;
  return (
    error.prepaid_amount?.message ||
    refErrors?.message ||
    refErrors?.invoice_number?.message ||
    refErrors?.invoice_uuid?.message ||
    refErrors?.invoice_date?.message ||
    null
  );
};

export default function AddPrepaymentDetailsButton({
  control,
  error,
  readOnly = false,
  currentNetAmount = 0,
  addPrepaymentDetails,
  addPrepaidAmount,
  getValues,
}) {
  const [modalOpen, setModalOpen] = React.useState(false);
  const ref = getValues?.("prepayment_invoice_reference") || {};
  const prepaymentErrorMessage = getPrepaymentErrorMessage(error);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Button
          id="prepayment-details"
          variant="contained"
          color={prepaymentErrorMessage ? "error" : "primary"}
          onClick={handleOpenModal}
        >
          {readOnly ? <VisibilityIcon fontSize="small" sx={{ mr: 1 }} /> : "+ "}
          Prepayment Details
        </Button>
        {prepaymentErrorMessage && (
          <FormHelperText error sx={{ m: 0 }}>
            {prepaymentErrorMessage}
          </FormHelperText>
        )}
      </Box>
      <PrepaymentDetailsModal
        open={modalOpen}
        onClose={handleCloseModal}
        readOnly={readOnly}
        currentNetAmount={currentNetAmount}
        addPrepaidAmount={addPrepaidAmount}
        addPrepaymentDetails={addPrepaymentDetails}
        initialValue={{
          prepaid_amount: getValues?.("prepaid_amount") || 0,
          invoice_number: ref.invoice_number ?? "",
          invoice_uuid: ref.invoice_uuid ?? "",
          invoice_date: dayjs(ref.invoice_date) ?? null,
        }}
      />
    </div>
  );
}
